import React, { FC } from 'react';
import Image from 'components/image/Image';
import { IActivationPage } from 'core/interface/activation';
import Steps from 'components/shared/Step/Index';

import './Index.scss';
import { useTenantInfo } from 'hooks/useTenantInfo';

const Activation: FC<IActivationPage> = ({
  title,
  children,
  sub_title,
  currentStep,
  totalSteps = 5,
  className,
  showTopSide = true,
  isPopup = false,
  headerIconDisable,
  isCareerPage,
  handleModalClose,
  showTitle,
  style
}): JSX.Element => {
  const { tenantLogo } = useTenantInfo();

  return (
    <div
      className={
        currentStep == 5
          ? 'scrollable activation'
          : headerIconDisable
            ? 'fromCareer'
            : isPopup
              ? ''
              : `activation ${className ?? ''}`
      }
      style={style}
    >
      <div className="activation__body">
        {isCareerPage && (
          <span
            className="popup__content__main-close"
            onClick={handleModalClose}
          >
            <Image name="close.svg" width={22} height={22} />
          </span>
        )}
        {showTopSide && (
          <>
            {!headerIconDisable &&
              (tenantLogo ? (
                <Image
                  url={tenantLogo}
                  className="activation__body-logo"
                  width={210}
                  objectFit="contain"
                />
              ) : (
                <Image
                  name="new-rec-logos.svg"
                  className="activation__body-logo"
                  width={210}
                  height={95}
                />
              ))}
            <span className="activation__body-title">{title}</span>
            {currentStep && (
              <div className="activation__body-step">
                <Steps totalSteps={totalSteps} currentStep={currentStep} />
              </div>
            )}
            {sub_title && (
              <span className="activation__body-sub">{sub_title}</span>
            )}
          </>
        )}
        {showTitle && <span className="activation__body-title">{title}</span>}

        {children && <div className="activation__body-content">{children}</div>}
      </div>
    </div>
  );
};

export default Activation;
